import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/resources/events-and-callbacks/events-and-callbacks.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
